module.exports = __webpack_public_path__ + "static/media/no-image.e9612a84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no-image.jpg
// module id = 167
// module chunks = 0